export const environment = {
	production: true,
	servicesEndpointRoot: 'https://go-api.naar.com/',
	i18nFiles: 'i18n/',
	azureCommunication: {
		endpoint: 'https://naargocommunicationservice.europe.communication.azure.com',
		accesskey: '7P3SGFun1NMGzVryHiIoa9IrxATPysMUxS69uFIuYL0snaWdrmm4JQQJ99BFACULyCp5biVRAAAAAZCSI7q3'
	}
};
